import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  ChakraProvider,
  Flex,
} from "@chakra-ui/react";
import { isError } from "remeda";

export function FullpageErrorDisplay({
  title = "Something went wrong",
  error,
}: {
  title?: string;
  error: unknown;
}) {
  return (
    <ChakraProvider>
      <Flex w="100vw" h="100vh" alignItems="center" justifyContent="center">
        <Alert status="loading" maxW={"container.sm"}>
          <AlertIcon />
          <AlertTitle>{title}</AlertTitle>
          <AlertDescription>
            {isError(error) ? error.message : String(error)}
          </AlertDescription>
        </Alert>
      </Flex>
    </ChakraProvider>
  );
}
